import firebase from 'firebase'
import 'firebase/firestore'

// wizu: NB companiesCollection ook aanpassen
// const firebaseConfig = {
//     apiKey: "AIzaSyA8EdwMPYtzFGcqzZNkIBssW-BQd8Wfz7I",
//     authDomain: "wizu-866af.firebaseapp.com",
//     databaseURL: "https://wizu-866af.firebaseio.com",
//     projectId: "wizu-866af",
//     storageBucket: "wizu-866af.appspot.com",
//     messagingSenderId: "502448949206",
//     appId: "1:502448949206:web:3400ef9b9519c427044677",
//     measurementId: "G-D3ZF64BP22"
// };

//ScaPP:
// const firebaseConfig = {
//     apiKey: "AIzaSyBr6u5fxmNKon7PaK1gGlbxDVaPpjeOsEQ",
//     authDomain: "scapp-4e0b4.firebaseapp.com",
//     databaseURL: "https://scapp-4e0b4.firebaseio.com",
//     projectId: "scapp-4e0b4",
//     storageBucket: "scapp-4e0b4.appspot.com",
//     messagingSenderId: "22645487181",
//     appId: "1:22645487181:web:e69ea3e14c7c2351b0ce04",
//     measurementId: "G-QD1TQMVMLH"
// };


// smoelenboek: NB companiesCollection ook aanpassen
const firebaseConfig = {
    apiKey: "AIzaSyAQck__whvnLKydad2cbZ16hSlWrTV6_vU",
    authDomain: "smoelenboek-be952.firebaseapp.com",
    databaseURL: "https://smoelenboek-be952.firebaseio.com",
    projectId: "smoelenboek-be952",
    storageBucket: "smoelenboek-be952.appspot.com",
    messagingSenderId: "124441812007",
    appId: "1:124441812007:web:1b982b5b2814c913238202",
    measurementId: "G-R3395F5E49"
};


firebase.initializeApp(firebaseConfig);
//firebase.analytics();

const db = firebase.firestore();
const auth = firebase.auth();
const firestorage = firebase.storage();
const currentUser = auth.currentUser;


const usersCollection = db.collection('users')
const notificationsCollection = db.collection('notifications')
const companiesCollection = db.collection('company') //smoelenboek
    //const companiesCollection = db.collection('companies') //wizu, scapp
const env = firebaseConfig.projectId


export {
    db,
    auth,
    firestorage,
    currentUser,
    usersCollection,
    companiesCollection,
    notificationsCollection,
    env
}